var React = require('react');

function Square (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"1.49428","y":"10.5736","width":"33.9258","height":"33.9258","transform":"rotate(-15 1.49428 10.5736)","stroke":"white","strokeWidth":"2"}));
}

Square.defaultProps = {"width":"45","height":"45","viewBox":"0 0 45 45","fill":"none"};

module.exports = Square;

Square.default = Square;
